import React from 'react';
import ChoiceButton from './ChoiceButton';

const waterColorScheme = {
  bgColor: '#F0F7FF',
  labelShadowColor: 'rgba(59, 130, 246, 0.40)',
  labelDropShadowColor: 'rgba(59, 130, 246, 0.40)',
  textColor: '#3B82F6',
  activeGradientStart: '#1D4ED8',
  activeGradientEnd: '#3B82F6',
  activeBorderGradientStart: '#BFDBFE',
  activeBorderGradientEnd: '#1E40AF',
  activeBoxShadowColor: '#93C5FD',
  activeLabelInnerBg: '#3B82F6',
};

const WaterChoiceButton = (props) => {
  return <ChoiceButton {...props} colorScheme={waterColorScheme} />;
};

export default WaterChoiceButton;
